exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loading{display:block;position:relative;top:110px;height:100%}loading .loading{display:flex;height:100%;width:100%}loading img{margin-left:auto;margin-right:auto;width:60px;height:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/loading/loading.scss
// module id = 739
// module chunks = 0